/**
 * Per-NPC traits — desyncs timers and path choices from the crowd.
 */
export class NPCPersonality {
  /**
   * @param {number} seed
   * @param {typeof import('../config.js').CONFIG['npc']} config
   */
  constructor(seed, config) {
    this._seed = seed >>> 0;
    const p = config.personality;

    this.speedMultiplier = this._range(
      p.speedMultiplierMin,
      p.speedMultiplierMax,
    );
    this.waitScale = this._range(p.waitScaleMin, p.waitScaleMax);
    this.intersectionPatience = this._range(0.7, 1.35);
    /** 0 = random wander, 1 = prefers far destinations */
    this.destinationBias = this._range(0, 1);
    /** 0 = straight commutes, 1 = frequent detours */
    this.detourAffinity = this._range(0, 1);
    this.lookAroundChance = this._range(
      p.lookAroundChanceMin,
      p.lookAroundChanceMax,
    );
    this.phaseOffset = this._range(0, Math.PI * 2);
    this.timerJitter = this._range(0.15, 2.4);

    this.groupAffinity = this._range(0, 1);
    /** @type {number | null} */
    this.groupLeaderId = null;
    /** @type {number[]} */
    this.groupMemberIds = [];
    this.isGroupLeader = false;
  }

  /** @param {number} min @param {number} max */
  _range(min, max) {
    return min + (this._hash() % 1000) / 1000 * (max - min);
  }

  _hash() {
    this._seed = (1664525 * this._seed + 1013904223) >>> 0;
    return this._seed;
  }

  /** Personal idle duration (seconds) at destinations. */
  destinationWait(config) {
    const base =
      config.waitTimeMin +
      (this._hash() % 1000) / 1000 *
        (config.waitTimeMax - config.waitTimeMin);
    return base * this.waitScale * (0.85 + (this._hash() % 100) / 333);
  }

  intersectionWait(config) {
    const { intersectionWaitMin, intersectionWaitMax } = config;
    return (
      (intersectionWaitMin +
        ((this._hash() % 1000) / 1000) *
          (intersectionWaitMax - intersectionWaitMin)) *
      this.intersectionPatience
    );
  }

  clearGroup() {
    this.groupLeaderId = null;
    this.groupMemberIds = [];
    this.isGroupLeader = false;
  }
}
